import App, { Container } from "next/app";
import React from "react";
import withReduxStore from "../lib/with-redux-store";
import { Provider } from "react-redux";
import Head from "../components/Head";

import "@fortawesome/fontawesome-svg-core/styles.css";
import "../styles/style.scss";

import { config as configFA } from "@fortawesome/fontawesome-svg-core";
configFA.autoAddCss = false;

import { routerPush } from "../config/utils";

import { setAccount } from "../store";

class MyApp extends App {
    static async getInitialProps({ Component, ctx }) {
        let pageProps = {};

        if (Component.getInitialProps) {
            pageProps = await Component.getInitialProps(ctx);
        }

        if (ctx.req) {
            // Antes: self-fetch HTTP a /api/checkuserlogged durante el SSR.
            // Es un anti-patrón de Next con custom server: el server se pide a
            // sí mismo mientras renderea → en prod mode (next start) CUELGA con
            // "socket hang up" y la página nunca renderea. En dev nunca se notó.
            // ctx.req ya pasó por passport.session(), así que leemos req.user
            // directo — espeja exactamente verifyLogin (req.user si logueado,
            // else {err, logged:false}). Más rápido (sin round-trip) e idéntico
            // en dev y prod.
            const account = ctx.req.user || { err: true, logged: false };
            return { pageProps, account };
        }

        return { pageProps, account: {} };
    }

    constructor(props) {
        super(props);

        const { reduxStore, account } = this.props;

        if (account && !account.err) {
            reduxStore.dispatch(setAccount(account));
        }
    }

    render() {
        const { Component, pageProps, reduxStore } = this.props;
        return (
            <React.Fragment>
                <Head />
                <Provider store={reduxStore}>
                    <Component {...pageProps} />
                </Provider>
            </React.Fragment>
        );
    }
}

export default withReduxStore(MyApp);
